<template>
  <div class="nav--bg blogr-container" v-if="show">
    <nav class="nav">
      <ul class="nav__items products">
        <li class="nav__item">
          <label for="products"> product </label>
          <input type="checkbox" name="links" id="products">
          <img src="../../../assets/blogr/icon-arrow-dark.svg" alt="">
          <ul class="nav__items dropdown">
            <li class="nav__item">
              <a href="#" class="nav__link">overview</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">pricing</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">marketplace</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">features</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">integration</a>
            </li>
          </ul>
        </li>
        <li class="nav__item">
          <label for="company"> company </label>
          <input type="checkbox" name="links" id="company">
          <img src="../../../assets/blogr/icon-arrow-dark.svg" alt="">
          <ul class="nav__items dropdown">
            <li class="nav__item">
              <a href="#" class="nav__link">about</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">team</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">blog</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">career</a>
            </li>
          </ul>
        </li>
        <li class="nav__item">
          <label for="connect"> connect </label>
          <input type="checkbox" name="links" id="connect">
          <img src="../../../assets/blogr/icon-arrow-dark.svg" alt="">
          <ul class="nav__items dropdown">
            <li class="nav__item">
              <a href="#" class="nav__link">contact</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">newsletter</a>
            </li>
            <li class="nav__item">
              <a href="#" class="nav__link">linkedin</a>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="nav__items user">
        <li class="nav__item">
          <a href="#" class="nav__link">login</a>
        </li>
        <li class="nav__item">
          <a href="#" class="nav__link button">sign up</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.blogr-container {
  width: 95%;
}

/* breakpoints */
$desktop-media: 75em;

.nav {
  color: var(--very-dark-gray-blue);

  &--bg {
    background-color: var(--white);
    padding: calc(var(--sm-spacer) * 1.5);

    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    transform: translateY(-50%);
    opacity: 0;

    border-radius: var(--border-radius);
    box-shadow: 0 0 10px 3px rgba(0,0,0, 0.5);

    transition: drop 200ms linear;
    animation: drop 200ms linear forwards;

    @keyframes drop {
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    @media(min-width: $desktop-media) {
      display: none;
    }
  }

  input {
    position: absolute;
    opacity: 0;
  }

  .dropdown {
    background-color: var(--light-grayish-blue);
    border-radius: var(--border-radius);
    transition: all 200ms linear;

    height: 0;
    overflow: hidden;
  }

  &__items {
    list-style: none;
    text-transform: capitalize;
  }

  .user {
    border-top: 1px solid var(--grayish-blue);
    margin-top: calc(var(--sm-spacer) / 2);
    padding-top: calc(var(--sm-spacer) / 2);
  }

  &__item {
    label, img {
      cursor: pointer;
    }
  }

  &__item + &__item{
    padding-top: calc(var(--sm-spacer) / 2);
  }

  &__link {
    color: inherit;
    text-decoration: none;
  }

  .button {
    color: var(--white);
    font-family: var(--ff-alt);
    font-size: var(--fs-h3);
    font-weight: var(--fw-700);
    box-shadow: none;
    border: none;
    background: linear-gradient(to right,
                                var(--g-very-light-red),
                                var(--g-light-red));
    padding: 0.5rem 2rem;
  }

  #products:checked ~ ul,
  #company:checked  ~ ul,
  #connect:checked  ~ ul {
    height: max-content;
    padding: calc(var(--sm-spacer) / 2) 0;
    margin: calc(var(--sm-spacer) / 2) 0;
  }

  #products:checked + img,
  #company:checked + img,
  #connect:checked + img {
    transform: rotate(180deg);
  }

  @media (min-width: $desktop-media) {
    display: none;
  }

  @media (max-width: $desktop-media) {
    display: initial;
  }
}
</style>
